module.exports = __webpack_public_path__ + "img/icon-plta.9d34d85f.png";